import React, {useEffect, useState} from "react";
import {fetchPost} from "../../utils/FetchUtil.ts";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";
import {isNotEmpty} from "../../utils/CommonUtil.ts";
import {Image} from "react-bootstrap";
import {url} from "../../utils/UrlsUtil.ts";
import {img} from "../../utils/ImageUtil.ts";
import "../../../style/common/components/swiper/event_msg_samples_swiper.scss";

interface EventMsgSamplesSwiperProps {
    genre: string;
    showSample?: boolean;
    onSelectedMsg?: (msg: string) => void;
    onSelectedCategory?: (code: string) => void;
}
const EventMsgSamplesSwiper:React.FC<EventMsgSamplesSwiperProps> = (
    {
        genre = '',
        showSample = true,
        onSelectedMsg = () => {},
        onSelectedCategory = () => {},
    }
) => {
    const [selectedCategoryCode, setSelectedCategoryCode] = useState<string>("");
    const [eventCategoryList, setEventCategoryList] = useState<EventCategoryDto[]>([]);
    const [sampleList, setSampleList] = useState<SampleMessageDto[]>([]);
    useEffect(() => {
        const getEventCategoryList = async () =>{
            try{
                const data = await fetchPost({
                    action: "/api/event/message/categories",
                    data: {},
                });
                if(data != null){
                    //オンラインメッセージサンプルリスト
                    setEventCategoryList(data);
                }
            }catch (e) {
                console.log(e);
            }
        }
        getEventCategoryList().finally(()=>{});
    }, []);
    useEffect(() => {
        const getMessageSampleList = async () =>{
            try{
                const data = await fetchPost({
                    action: "/api/event/message/samples",
                    data: {genre: genre, event_category_code: selectedCategoryCode},
                });
                if(data != null){
                    //イベントカテゴリーメッセージテンプレートを取得
                    setSampleList(data);
                }
            }catch (e) {
                console.log(e);
            }
        }
        if(showSample){
            getMessageSampleList().finally(()=>{});
        }
    }, [selectedCategoryCode]);
    const onClickCategory = (code: string) => {
        setSelectedCategoryCode(code);
        onSelectedCategory(code);
    }
    if(eventCategoryList && eventCategoryList.length > 0){
        return (
            <div className="event-msg-samples-cont">
                <Swiper spaceBetween={20}
                        slidesPerView={4}
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }}
                        modules={[Navigation]}
                        breakpoints={{
                            768: {slidesPerView: 4}
                        }}
                        className="event-categories-swiper"
                >
                    <SwiperSlide onClick={()=>{onClickCategory("");}}>
                        <dl className={`event-category-item${isNotEmpty(selectedCategoryCode)? '' : ' selected-item'}`}>
                            <dd><Image src={url("/images/common/all.png")} fluid={true}></Image></dd>
                            <dt>すべて</dt>
                        </dl>
                    </SwiperSlide>
                    {eventCategoryList.map( ((eventCategory, idx) => (<SwiperSlide key={`event_category_item_${idx}`} onClick={()=>{onClickCategory(eventCategory.code);}}>
                        <dl className={`event-category-item${eventCategory.code === selectedCategoryCode ? ' selected-item' : ''}`}>
                            <dd><Image src={img(eventCategory.icon_path)} fluid={true}></Image></dd>
                            <dt>{eventCategory.name}</dt>
                        </dl>
                    </SwiperSlide>)))}
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                </Swiper>
                {showSample && <Swiper spaceBetween={20}
                                         slidesPerView={3}
                                         centeredSlides={false}
                                         navigation={{
                                             nextEl: '.swiper-button-next',
                                             prevEl: '.swiper-button-prev',
                                         }}
                                         modules={[Navigation]}
                                         className="event-msg-template-swiper"
                >
                    {sampleList.map( ((msg: SampleMessageDto, idx: number) => (
                        <SwiperSlide key={`msg_template_item_${idx}`} onClick={()=>{onSelectedMsg(msg.sample_message);}}>
                            <dl className={`msg-template-item`}>
                                <dt>{msg.title}</dt>
                                <dd dangerouslySetInnerHTML={{ __html: msg.sample_message.replace(/<br\s*\/?>/g, '\n').replace(/\n/g, '<br />')}}></dd>
                            </dl>
                        </SwiperSlide>
                    )))}
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                </Swiper>}
            </div>
        );
    }else {
        return <></>;
    }
};
export default EventMsgSamplesSwiper;